// extracted by mini-css-extract-plugin
export default {"container":"Canvas_container__M0c-K","preview":"Canvas_preview__Jpn88","settings":"Canvas_settings__BEGzf","center-vert":"Canvas_center-vert__RnXB6"};